import React, { useState }                          from 'react';
import { useDispatch, useSelector }                 from 'react-redux';
import { Button }                                   from 'react-bootstrap';

import AccusedResultInfo                            from '../info/items/AccusedResultInfo';
import { AGENDADA }                                 from '../../../../data/audienceStates';
import { anulateAccusedResultAction }               from '../../../../actions/audiencesActions';
import AuthoritiesService                           from '../../../../services/AuthoritiesService';
import { ICON_ACCUSED, ICON_REMOVE, ICON_SEARCH }   from '../../../extras/icons';
import ReduxAccusedResultForm                       from './forms/ReduxAccusedResultForm';
import { RESULTADOS_CREAR }                         from '../../../../data/objects';
import Swal                                         from 'sweetalert2';



const AccusedListRow = props => {


    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { accused, audience, tipos } = props;
    
    // Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    
    // Inicializo el state local
    const [show, setShow] = useState(false);    
    const [showInfo, setShowInfo] = useState(false);

    // Inicializo el Dispatch
    const dispatch = useDispatch();


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo el modal del form
    const handleOpen = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }    

    // Manejo el modal de info
    const handleOpenInfo = () => {        
        setShowInfo(true);
    }
    const handleCloseInfo = () => {
        setShowInfo(false);
    }

    // Eliminar Resultados
    const handleRemoveResult = () => {
        Swal.fire({
            title: 'Eliminar Resultado?',
            text: 'La operación no se podrá revertir',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e74a3b',
            confirmButtonText: 'Si, Eliminar'
        }).then((result) => {
            if(result.value)
            {   const auxAudience = {
                    ...audience,
                    imputadoList: audience.imputadoList.map(el=>
                        el.id===accused.id  
                            ?
                                {   ...el,
                                    resultado: null
                                }
                            :
                                el
                        )
                };   
                //Llamo al dispatch
                dispatch( anulateAccusedResultAction(auxAudience, accused) );
            }
        })        
    }


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <tr key={`ata${accused.id}`}>
            <td className="align-middle text-center">
                { accused.persona.apellido + ', ' + accused.persona.nombre }
            </td>
            <td className="align-middle text-center">
                { accused.persona.tipoDocumento + ' ' + accused.persona.identificacion }
            </td>
            <td className="align-middle text-center">
                {   authorities && AuthoritiesService.hasPermission(authorities, RESULTADOS_CREAR) 
                        ?
                            audience.estado.id === AGENDADA 
                                ?
                                    !accused.resultado
                                        ?
                                            <Button key={accused.resultado?.length} variant="warning" size="sm" onClick={handleOpen}>
                                                <ICON_ACCUSED />
                                            </Button>
                                        :
                                            <>
                                                <Button key={accused.resultado?.length} variant="info" size="sm" onClick={handleOpen}>
                                                    <ICON_SEARCH />
                                                </Button>
                                                &nbsp;
                                                <Button key={accused.resultado?.length} variant="danger" size="sm" onClick={handleRemoveResult}>
                                                    <ICON_REMOVE />
                                                </Button>
                                            </>
                                :
                                    <>
                                        <Button variant="info" size="sm" onClick={handleOpenInfo}>
                                            <ICON_SEARCH />
                                        </Button>
                                    </>
                        :
                            null
                }

                <ReduxAccusedResultForm
                    accused = { accused }
                    audience = { audience }
                    handleClose = { handleClose }
                    show = { show }
                    tipos = { tipos }
                />

                <AccusedResultInfo
                    accused = { accused }
                    audience = { audience }
                    handleClose = { handleCloseInfo }
                    show = { showInfo }
                />

            </td>
        </tr>
    );
};

export default AccusedListRow;